import debounce from 'lodash/debounce.js';
import { useEffect, useLayoutEffect, useMemo } from 'react';
import { useChgState } from './useChgState.js';
import { useInit } from './useInit.js';
export const useDebouncedValue = (value, ms) => {
    const [_value, _setValue] = useChgState(value);
    const isInit = useInit();
    const setValue = useMemo(() => debounce(_setValue, ms), [ms]);
    useLayoutEffect(() => {
        // NOTE: We do an isInit check here so we don't trigger debounce condition
        if (!isInit())
            return;
        setValue(value);
    }, [value]);
    useEffect(() => () => setValue.cancel(), []);
    return _value;
};
//# sourceMappingURL=useDebouncedValue.js.map